// extracted by mini-css-extract-plugin
export default {"card":"FeatureCard_card__DQV78","avatar":"FeatureCard_avatar__4PBSB","button":"FeatureCard_button__K9+oX"};